<template>
	<div class="draw">
		<Teleport to="body">
			<div class="draw__fixed" @click="openModal">
				<button class="draw__btn btn">Создание розыгрыша</button>
				<svg class="draw__fixed-icon"><use href="#svg-icon-roulette"></use></svg>
			</div>
			<Modal :class="[draw ? 'draw__modal' : '']" :openState="open" :data="{title: modalTitle}" @close="handlerClose">
				<div v-if="!draw">
					<div class="fields__item">
						<label class="field-input__label">Сумма конкурса</label>
						<input class="field-input__input" type="number" v-model="amount" autocomplete="off">
					</div>
					<div class="fields__item">
						<label class="field-input__label">Для кого</label>
						<FieldSelect :options="selectTarget" :value="selectedTarget" @update:model-value="option => selectedTarget = option"/>
					</div>
					<div class="fields__item">
						<label class="field-input__label">Время</label>
						<FieldSelect :options="selectTime" :value="selectedTime" @update:model-value="option => selectedTime = option"/>
					</div>
					<div class="fields__item">
						<label class="field-input__label">Депозит</label>
						<FieldSelect :options="selectDeposit" :value="selectedDeposit" @update:model-value="option => selectedDeposit = option"/>
					</div>
					<div class="fields__item">
						<button :disabled="!amount" @click="createDraw" class="btn btn--block">Запустить</button>
					</div>
				</div>
				<div v-else-if="!winner">
					<div class="draw__share">
						<button class="draw__share-btn" @click="copyLink">
							<svg class="draw__share-btn-icon">
								<use href="#svg-icon-share"></use>
							</svg>
							Пригласить участников
						</button>
					</div>
					<div class="draw__main">
						<div class="draw__progress">
							<svg class="draw__progress-svg" viewBox="0 0 250 250">
								<circle class="bg"></circle>
								<circle class="fg"></circle>
							</svg>
							<div class="draw__main-info">
								<div class="draw__main-users">Участники {{users.length}}</div>
								<div class="draw__timer">
									<div>{{countdown > 60 ? formattedTime(countdown) : countdown}}</div>
									<div>{{countdown > 60 ? 'мин' : 'сек'}}</div>
								</div>
							</div>
						</div>
					</div>
					<div class="draw__users-head">
						<div class="draw__users-title">Последние участники</div>
						<div class="draw__amount">Монет {{amount}}</div>
					</div>
					<div class="draw__users">
						<div class="draw__user" v-for="user in users" @click="this.testWinner = user">
							{{user.username}}
						</div>
					</div>
				</div>
				<div v-else-if="winner && !showWinner">
					<div class="draw__results">
						<div class="draw__results-label">Сумма конкурса</div>
						<div class="draw__results-value">{{amount}}</div>
					</div>
					<div class="draw__wheel no-scrollbar" ref="wheel">
						<div class="draw__wheel-items" ref="wheelItems" @transitionend="handlerShowWinner">
							<template v-for="(group, i) in [users, users, users, users]">
								<div v-for="user in group" class="draw__wheel-item" :id="i + 1 === 4 ? user.id : null">
									<div class="draw__wheel-item-frame" >
										<span class="draw__wheel-item-name">{{user.username}}</span>
									</div>
								</div>
							</template>
						</div>
					</div>
					<div class="draw__wheel-note">
						Выбираем счастливчика из
						<span class="draw__wheel-note-count">{{users.length}}</span>
						игроков
					</div>
				</div>
				<div v-else-if="winner && showWinner">
					<div class="draw__results">
						<div class="draw__results-title">Победитель!</div>
						<div class="draw__results-label">Сумма конкурса</div>
						<div class="draw__results-value">{{amount}}</div>
					</div>
					<div class="draw__winner">
						<div class="draw__results-title">{{winner.username}}</div>
					</div>
				</div>
			</Modal>
		</Teleport>
	</div>
</template>

<script>

import Modal from "./Modal.vue";
import FieldSelect from "../../components/blocks/FieldSelect.vue";
import { mapState } from 'pinia';
import { useUserStore } from '../../stores/User';

export default {

	components: {
		Modal,
		FieldSelect
	},

	emits: [
		'open-state'
	],

	data() {
		return {
			open: false,
			amount: 1000,
			draw: null,
			docRoot: document.querySelector(':root'),
			countdown: null,
			selectedTime: {
				id: 0,
				name: '5 секунд',
				value: 5
			},
			selectedTarget: {
				id: 333,
				name: 'Для рефералов',
				value: 333
			},
			selectedDeposit: {
				id: 555,
				name: 'Депозит',
				value: 555
			},
			selectTarget: [
				{
					id: 333,
					name: 'Для рефералов',
					value: 333
				},
				{
					id: 333,
					name: 'Для всех',
					value: 333
				}
			],
			selectDeposit: [
				{
					id: 222,
					name: 'Без депозита',
					value: 222
				},
				{
					id: 555,
					name: 'Депозит',
					value: 555
				},
				{
					id: 666,
					name: 'Депозит за 7 дней',
					value: 666
				}
			],
			selectTime: [
				{
					id: 0,
					name: '5 секунд',
					value: 5
				},
				{
					id: 1,
					name: '1 минута',
					value: 60
				},
				{
					id: 2,
					name: '2 минуты',
					value: 120
				},
				{
					id: 3,
					name: '3 минуты',
					value: 180
				},
				{
					id: 4,
					name: '5 минут',
					value: 300
				},
				{
					id: 5,
					name: '10 минут',
					value: 600
				}
			],
			users: [
				{
					id: 123,
					username: 'Татьяна П.Татьяна П.'
				},
				{
					id: 124,
					username: 'Кирилл Г.'
				},
				{
					id: 125,
					username: 'Максим А.'
				},
				{
					id: 126,
					username: 'Павел У.'
				},
				{
					id: 127,
					username: 'Дмитрий Д.'
				},
				{
					id: 128,
					username: 'Стас П.'
				},
				{
					id: 129,
					username: 'Татьяна D.'
				},
				{
					id: 132,
					username: 'Кирилл G.'
				},
				{
					id: 133,
					username: 'Максим S.'
				},
				{
					id: 134,
					username: 'Павел T.'
				},
				{
					id: 135,
					username: 'Дмитрий H.'
				},
				{
					id: 136,
					username: 'Стас H.'
				}
			],
			winner: null,
			showWinner: false,
			countdownTimeout: null
		}
	},

	watch: {
		open(state) {
			this.$emit('open-state', state);
		},

		countdown(state) {
			if (state || state === 0) {
				if (state) {
					this.setProgress(state - 1);
				} else {
					this.startDraw();
				}
				this.countdownTimeout = setTimeout(() => this.countdown = state ? state - 1 : 0, 1000);
			}
		}
	},

	computed: {
		...mapState(useUserStore, ['user']),
		
		modalTitle() {
			return this.winner ? 'Итоги' : this.draw ? 'Ожидание результатов' : 'Создние конкурса'
		}
	},

	mounted() {
		this.handlerReset();
	},

	methods: {

		openModal() {
			this.open = true;
		},

		createDraw() {
			this.draw = {
				id: 'draw-id-test',
				link: 'draw-text-link'
			}
			setTimeout(() => this.countdown = this.selectedTime.value, 0);
		},

		setProgress(val) {
			this.docRoot.style.setProperty('--progress', (this.selectedTime.value - val) * 100 / this.selectedTime.value);
		},

		handlerClose() {
			this.open = false;
			this.handlerReset();
		},

		handlerReset() {
			this.draw = null;
			this.amount = 1000;
			this.winner = null;
			this.countdown = null;
			this.showWinner = false;
			clearTimeout(this.countdownTimeout);
			this.docRoot.style.setProperty('--progress', 0);
		},

		startDraw() {
			console.log('Start draw');
			this.winner = this.testWinner || this.users[3];
			setTimeout(this.scrollToWinner,0)

		},

		copyLink() {
			navigator.clipboard.writeText(this.text);
			this.$toast.success('Успешно скопировано');
		},

		scrollToWinner() {
			let winner = document.getElementById(this.winner.id);
			if (winner) {
				this.$refs.wheelItems.style.transform = `translateX(-${winner.offsetLeft + this.getRandom(winner.clientWidth * 0.2, winner.clientWidth * 0.8) - this.$refs.wheel.clientWidth / 2}px)`
			}
		},

		handlerShowWinner() {
			setTimeout(() => this.showWinner = true, 1000);
		},

		getRandom(min, max) {
			return Math.random() * (max - min) + min;
		},

		formattedTime(time) {
			let minutes = Math.floor(time / 60);
			let seconds = (time % 60).toFixed(0);
			return (minutes ? minutes + ":" : '') + (seconds < 10 ? '0' : '') + seconds;
		}
	}
}

</script>